<script>
import { HomePage } from '@/api'
import PageFormBase from '@/crudBases/form/PageFormBase'
import fields from '@/components/fields/'

export default {
  extends: PageFormBase,
  data() {
    return {
      livePreview: true,
      redirectRoute: { name: 'Home' },
      selectedTab: 'general',
      form: {
        links: []
      },
      slugFieldDisabled: true,
      pageType: 'HomePage'
    }
  },
  methods: {
    getGeneralFields() {
      return [
        new fields.Input({
          label: 'Tytuł',
          modelPath: [this, 'form', 'title'],
          required: true
        }),
        new fields.WYSIWYG({
          label: 'Lead',
          modelPath: [this, 'form', 'lead'],
          required: true,
          type: 'emptyMenuBarInit'
        }),
        new fields.WYSIWYG({
          label: 'Wyróżniony lead',
          modelPath: [this, 'form', 'highlighted_lead'],
          required: true,
          type: 'emptyMenuBarInit'
        }),
        new fields.HomePageVideo({
          label: 'Video',
          modelPath: [this, 'form', 'video'],
          required: true
        })
      ]
    }
  },
  computed: {
    service() {
      return HomePage
    }
  }
}
</script>
